import { RemoteCreateEvaluationCriteria } from 'data/usecases';
import { makeApiUrlEvaluationCriteria } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateEvaluationCriteria =
  (): RemoteCreateEvaluationCriteria => {
    return new RemoteCreateEvaluationCriteria(
      makeApiUrlEvaluationCriteria(),
      makeAxiosHttpClient(),
    );
  };
